import { ProjectDetailsDto } from 'types/projects.ts';
import { RSQL_AND } from 'utils/filterUtil.ts';
import ExpensesTable from '../../expenses/ExpensesTable.tsx';

type Props = {
    project: ProjectDetailsDto;
};
const ExpensesView = ({ project }: Props) => {
    const matterIds = project.matters?.map((m) => m.id) ?? [];
    const joinedMatterIds = matterIds.length > 0 ? matterIds.join(',') : '0';
    return (
        <div className="flex h-full flex-col gap-4">
            <ExpensesTable
                passiveFilter={`matter.id=in=(${joinedMatterIds})`}
                disableExport
                paginatedFieldPassiveFilters={[
                    {
                        filterId: 'matterIdInFilter',
                        filters: `id=in=(${joinedMatterIds})`,
                        filterOperator: RSQL_AND,
                    },
                ]}
            />
        </div>
    );
};

export default ExpensesView;
